<div #ngContentRef><ng-content></ng-content></div>
<div *ngIf="!ngContentRef.hasChildNodes()">
    <fc-responsive-ag-grid-desktop *ngIf="!gridOptions.isMobileMode" [gridOptions]="gridOptions"></fc-responsive-ag-grid-desktop>
    <fc-responsive-ag-grid-mobile *ngIf="gridOptions.isMobileMode" [gridOptions]="gridOptions"></fc-responsive-ag-grid-mobile>
    <fc-responsive-ag-grid-paging *ngIf="gridOptions.enablePagination" [gridOptions]="gridOptions"></fc-responsive-ag-grid-paging>
</div>